import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { recordPageView, startTracking } from './tracker';

// Mounted once inside <BrowserRouter> in App.jsx so no screen carries tracking code. It renders
// nothing; useLocation is the only reason it is a component.
export default function ActivityTracker() {
  const { pathname, search } = useLocation();
  useEffect(() => startTracking(), []);
  useEffect(() => {
    recordPageView(pathname, search);
  }, [pathname, search]);
  return null;
}
